import React from 'react';
import { connect } from 'dva';
import { IVersion } from '../../abs/services/auth/authService';
import './index.less';
import { FILTER_DEFAULT_NOW_YEAR } from '../../utils/constant';
import ABSLink from '../ABSLink';

interface IABSFooterProps {
  version: IVersion;
}

class ABSFooter extends React.Component<IABSFooterProps> {
  renderICPContent() {
    return (
      <>
        <ABSLink to="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102006591">
          沪公网安备 31010102006591号
        </ABSLink>
        <ABSLink className="abs-href-icp" to="http://beian.miit.gov.cn">
          沪ICP备15008941号-1
        </ABSLink>
      </>
    );
  }
  render() {
    const { version } = this.props;
    return (
      <div className="abs-footer">
        © 2014 - {FILTER_DEFAULT_NOW_YEAR} 中诚信和逸信息科技（上海）有限公司版权所有
        {this.renderICPContent()} 版本号：{version ? version.versionNo : null}
      </div>
    );
  }
}

const mapStateToProps = ({ global }) => {
  return { version: global.version };
};

export default connect(mapStateToProps)(ABSFooter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFooter/index.tsx